import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ProductPurchaseFormType } from '../components/form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<ProductPurchaseFormType>();
  const [productPurchases, productPurchaseOtherFees, otherCost, discount] =
    useWatch({
      control,
      name: [
        'productPurchases',
        'productPurchaseOtherFees',
        'otherCost',
        'discount',
      ],
    });

  const data = React.useMemo(() => {
    const subtotal =
      productPurchases.reduce((prev, pp) => {
        const qty = pp.qty || 0;
        const price = pp.price || 0;
        return qty * price + prev;
      }, 0) +
      productPurchaseOtherFees.reduce((prev, fee) => {
        return prev + (fee.price || 0);
      }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [
    productPurchases,
    productPurchaseOtherFees,
    otherCost,
    discount,
    setValue,
  ]);

  return data;
}
